/**
 * @fileoverview Utility functions for color validation and processing.
 */

import {HIGH_CONTRAST_COLORS} from "../../pages/page-admin-organizations-branding/constants";

/**
 * Checks if a color is considered a high contrast color.
 *
 * @param {string} color The color to check.
 * @returns {boolean} True if the color is a high contrast color, false otherwise.
 */
export const isHighContrastColor = (color: string) =>
  HIGH_CONTRAST_COLORS.includes(color);
